import { HpAction, HpTemplateActionTypes } from '../actions/actionTypes';
import { CustomerSearchState, getInitialState } from './initialState';
import { ReducerProcessor } from './reducerProcessor';

const processor = new ReducerProcessor<CustomerSearchState, HpTemplateActionTypes>('customerSearch');

processor.add('SEARCH_VALIDATION_ERROR', (state, action) => {
  return {
    ...state,
    searchValidationErrors: action.payload
  };
});

processor.add('SEARCH_VALIDATION_SUCCESS', (state) => {
  return {
    ...state,
    searchProcessing: true,
    searchValidationErrors: undefined
  };
});

processor.add('CUSTOMER_SEARCH_ERROR', (state) => {
  return {
    ...state,
    searchProcessing: false,
    searchError: true,
    searchValidationErrors: undefined
  };
});

processor.add('CUSTOMER_SEARCH_SUCCESS', (state, action) => {
  return {
    ...state,
    searchProcessing: false,
    searchSuccess: true,
    searchError: false,
    searchResults: action.payload
  };
});

processor.add('CUSTOMER_SEARCH_RESET', (state) => {
  return {
    ...state,
    searchProcessing: false,
    searchSuccess: false,
    searchError: false,
    searchResults: [],
    searchValidationErrors: undefined
  };
});

export function customerSearchReducer(
  state: CustomerSearchState = getInitialState().customerSearch,
  action: HpAction<string | { [key: string]: string }>
): CustomerSearchState {
  return processor.process(state, action);
}
